import { post } from "@/utils/utils";
const onLineReport = {
    mutations: {
        ONLINE_REPORT(state, data) {
            state.onlineReportReq = data.result;
        },
    },
    actions: {
        onlineReportQuery({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryData`,
                name: "ONLINE_REPORT",
                params
            });
        }
    }
}

export default onLineReport;
